import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { artFor, imageChain } from './util.js';

// ---------- toast + drawer + printable sheet (ศูนย์กลางของ UI ชั้นบน) ----------
const UICtx = createContext(null);

export function UIProvider({ children }) {
  const [toastMsg, setToastMsg] = useState('');
  const [drawer, setDrawer] = useState(null);     // { eyebrow, title, body }
  const [sheet, setSheet] = useState(null);       // JSX ของเอกสาร

  const toast = useCallback((m) => {
    setToastMsg(m);
    clearTimeout(toast._t);
    toast._t = setTimeout(() => setToastMsg(''), 2600);
  }, []);

  const openDrawer = useCallback((eyebrow, title, body) => setDrawer({ eyebrow, title, body }), []);
  const closeDrawer = useCallback(() => setDrawer(null), []);
  const openSheet = useCallback((jsx) => setSheet(jsx), []);
  const closeSheet = useCallback(() => setSheet(null), []);

  useEffect(() => {
    const h = (e) => { if (e.key === 'Escape') { setSheet(null); setDrawer(null); } };
    document.addEventListener('keydown', h);
    return () => document.removeEventListener('keydown', h);
  }, []);

  return (
    <UICtx.Provider value={{ toast, openDrawer, closeDrawer, openSheet, closeSheet }}>
      {children}

      {sheet && (
        <div className="sheetwrap" onClick={(e) => { if (e.target.classList.contains('sheetwrap')) setSheet(null); }}>
          <div className="sheetbar">
            <button className="btn" onClick={() => window.print()}>พิมพ์ / บันทึก PDF</button>
            <button className="btn ghost" style={{ background: '#fff' }} onClick={() => setSheet(null)}>ปิด</button>
          </div>
          <div className="sheet">{sheet}</div>
        </div>
      )}

      <div className={'scrim' + (drawer ? ' on' : '')} onClick={closeDrawer} />
      <div className={'drawer' + (drawer ? ' on' : '')}>
        {drawer && (<>
          <div className="dw-head">
            <div>
              <div className="dw-eyebrow">{drawer.eyebrow}</div>
              <div className="dw-title">{drawer.title}</div>
            </div>
            <button className="dw-x" onClick={closeDrawer} aria-label="ปิด">✕</button>
          </div>
          <div>{drawer.body}</div>
        </>)}
      </div>

      <div className={'toast' + (toastMsg ? ' show' : '')}>{toastMsg}</div>
    </UICtx.Provider>
  );
}

export const useUI = () => useContext(UICtx);

// ---------- ชิ้นส่วนใช้ร่วม ----------
// รูปสินค้า: ลอง thumb 200px → รูปเต็ม → ลายเส้นตามหมวด (ลำดับเดียวกับ StockPoint/POS)
export function Pimg({ cat, size = 40, image }) {
  const chain = imageChain(image);
  const [stage, setStage] = useState(0);
  const [prev, setPrev] = useState(image);
  if (image !== prev) { setPrev(image); setStage(0); }   // รีเซ็ตเมื่อสลับสินค้าในลิสต์ที่ reuse ตัวเดิม
  const h = Math.round(size * 40 / 48);
  const src = chain[stage];
  if (src) {
    return <img src={src} alt="" loading="lazy" decoding="async"
      style={{ width: size, height: h, objectFit: 'contain' }}
      onError={() => setStage(s => s + 1)} />;
  }
  return (
    <svg className="pimg" viewBox="0 0 48 40"
      style={{ width: size, height: h }}
      aria-hidden="true" dangerouslySetInnerHTML={{ __html: artFor(cat) }} />
  );
}

export function Sec({ children }) { return <div className="dw-sec">{children}</div>; }
export function Row({ k, v, gold }) {
  return <div className="dw-row"><span>{k}</span><span className={'v' + (gold ? ' gold' : '')}>{v}</span></div>;
}
